import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
//Icons
import SearchIcon from "@mui/icons-material/Search";
//Import from project
import "../Style/pagestyle.scss";
import CreateIcon from "../Assets/create-icon.svg";
import EmptyData from "../Components/Include/EmptyData";
import LoadingPage from "../Components/Include/LoadingPage";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";
import FooterPagination from "../Components/Include/FooterPagination";
import CreateGroupFee from "../Components/GroupFee/CreateGroupFee";
import GroupFeeAction from "../Components/GroupFee/GroupFeeAction";
import { GET_GROUPFEE_PAGINATION } from "../Schema/GroupFee";
import { currencyFormat } from "../Function/DynamicFn";

export default function SetUpGroupFee() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const { refetch } = useQuery(GET_GROUPFEE_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
    },
    onCompleted: ({ getGroupFeePagination }) => {
      // console.log("getGroupFeePagination", getGroupFeePagination);
      setTableData(getGroupFeePagination?.data);
      setPaginationData(getGroupFeePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    if (tableData?.length !== 0) {
      let refetchData = tableData?.filter((d) => d?.role === null);
      if (refetchData?.length !== 0) {
        refetch();
      }
    }
  }, [tableData]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">{t("page_setting")}</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">Group Fee</Typography>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">Group Fee</Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} md={6} lg={3} xl={2.4}>
            <Typography className="search-head-title">Search</Typography>
            <TextField
              placeholder={"search"}
              size="small"
              className="search-field"
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#0f81c2" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={6} md={6} lg={9} xl={9.6}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                {t("create")}
              </Button>

              <CreateGroupFee
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start">{t("no")}</TableCell>
              <TableCell className="header-title">Group fee</TableCell>
              <TableCell className="header-title">Programme</TableCell>
              {/* <TableCell className="header-title">Class group</TableCell> */}
              {/* <TableCell className="header-title">Shift</TableCell> */}
              <TableCell className="header-title" align="right">
                Year cost
              </TableCell>
              <TableCell className="header-title" align="right">
                Semester cost
              </TableCell>
              <TableCell className="header-title" align="right">
                Quarter cost
              </TableCell>
              <TableCell className="header-title" align="right">
                Month cost
              </TableCell>
              <TableCell className="header-title">Income type</TableCell>
              <TableCell className="header-title">Note</TableCell>
              <TableCell className="header-title-end"></TableCell>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={20}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={20} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.groupFeeName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.programName}
                            </TableCell>
                            {/* <TableCell className="body-cell">
                              {row?.classGroupName}
                            </TableCell> */}
                            {/* <TableCell className="body-cell">
                              {row?.shiftName}
                            </TableCell> */}
                            <TableCell className="body-cell" align="right">
                              $ {currencyFormat(row?.academicYearCost)}
                            </TableCell>
                            <TableCell className="body-cell" align="right">
                              $ {currencyFormat(row?.academicTermCost)}
                            </TableCell>
                            <TableCell className="body-cell" align="right">
                              $ {currencyFormat(row?.quarterCost)}
                            </TableCell>
                            <TableCell className="body-cell" align="right">
                              $ {currencyFormat(row?.monthCost)}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.incomeType}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.note}
                            </TableCell>
                            <TableCell className="body-cell-end" align="right">
                              <GroupFeeAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
